import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';
import { Manager } from '~/clientApi/managers.model';
import { useTalentManager } from '~/hooks/useTalentManager';
import { USER_SETTINGS_QUERY_KEY } from '~/queries/keys';

export interface SettingsResult {
  '@id': string;
  '@type': string;
  id: string;
  notifyCreatorMilestones: boolean;
  notifyAdContent: boolean;
  notifyCreatorBirthday: boolean;
  notifyContentOutlier: boolean;
  notifyConnectionAndDisconnection: boolean;
  emailNotifyAdContent: boolean;
  emailNotifyCreatorMilestones: boolean;
  emailNotifyCreatorBirthday: boolean;
  emailNotifyContentOutlier: boolean;
  emailNotifyConnectionAndDisconnection: boolean;
  interfaceType?: 'fluid' | 'legacy';
  sendFoamWeeklyReport: boolean;
  manager: Manager;
  createdAt: string;
  updatedAt: string;
  createdAtAgo: string;
  updatedAtAgo: string;
}

export const useGetUserSettingsById = () => {
  const manager = useTalentManager();
  return useQuery<SettingsResult>({
    queryKey: [USER_SETTINGS_QUERY_KEY, 'MANAGER'],
    queryFn: () =>
      apiClientV2
        .get(`/settings/${manager.data?.setting.id}`)
        .then((res) => res.data),
    enabled: !!manager.data?.setting.id, // used to make requests only when logged in
  });
};
